var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-wrap" }, [
    _c(
      "div",
      { staticClass: "loginwrap", staticStyle: { width: "100%" } },
      [
        _c(
          "el-row",
          {
            attrs: {
              gutter: 20,
              type: "flex",
              justify: "space-between",
              align: "bottom",
            },
          },
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("h2", [_vm._v("Forgot your password?")]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showMessage === false
          ? _c("forgot-password-form", {
              attrs: { errors: _vm.authErrors, loading: _vm.loading },
              on: { submit: _vm.onSubmit },
            })
          : _c("p", { staticClass: "orangetext" }, [
              _vm._v("\n            " + _vm._s(_vm.showMessage) + "\n        "),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }